module.exports = __webpack_public_path__ + "static/9-min-90c88947ed5376a35d0cf0c83f202d2c.jpg";